/* Purchase options: switches between one-time purchase and a Shopify selling plan (Cool Tea). */
(function () {
  function formatNumber(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0];
    var out = '';
    while (whole.length > 3) {
      out = ',' + whole.slice(-3) + out;
      whole = whole.slice(0, -3);
    }
    return whole + out + '.' + parts[1];
  }

  function money(cents, format) {
    var amount = formatNumber(cents);
    var f = format || '${{amount}}';
    return f
      .split('{{amount}}').join(amount)
      .split('{{ amount }}').join(amount)
      .split('{{amount_no_decimals}}').join(amount.split('.')[0])
      .split('{{amount_with_comma_separator}}').join(amount.split(',').join('').split('.').join(','));
  }

  function init(root) {
    if (root.dataset.poReady) return;
    root.dataset.poReady = 'true';

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-po-json]').textContent);
    } catch (e) {
      return;
    }

    var section = root.closest('.shopify-section') || document;
    var form = section.querySelector('product-form form') || section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    var hidden = form.querySelector('input[name="selling_plan"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'selling_plan';
      form.appendChild(hidden);
    }

    var freq = root.querySelector('[data-po-freq]');
    var radios = root.querySelectorAll('.po__radio');
    var cards = root.querySelectorAll('[data-po-card]');
    var mode = root.querySelector('[data-po-card="one"]') ? (root.dataset.default === 'subscribe' ? 'sub' : 'one') : 'sub';

    function currentPlan() {
      var id = freq ? Number(freq.value) : (data.plans[0] && data.plans[0].id);
      for (var i = 0; i < data.plans.length; i++) {
        if (data.plans[i].id === id) return data.plans[i];
      }
      return data.plans[0];
    }

    function currentVariant() {
      var id = idInput ? String(idInput.value) : '';
      return data.variants[id] || data.variants[Object.keys(data.variants)[0]];
    }

    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }

    function render() {
      var v = currentVariant();
      var plan = currentPlan();
      if (!v || !plan) return;
      var subPrice = v.allocs[plan.id] != null ? v.allocs[plan.id] : v.price;
      var canSub = v.allocs[plan.id] != null;

      setText('[data-po-one-price]', money(v.price, data.money_format));
      setText('[data-po-sub-price]', money(subPrice, data.money_format));
      var compare = root.querySelector('[data-po-sub-compare]');
      if (compare) {
        compare.textContent = money(v.price, data.money_format);
        compare.hidden = subPrice >= v.price;
      }
      var badge = root.querySelector('[data-po-badge]');
      if (badge) {
        badge.textContent = plan.pct + '% OFF';
        badge.hidden = !plan.pct;
      }
      var b1 = root.querySelector('[data-po-b1]');
      if (b1) b1.hidden = !plan.pct;
      setText('[data-po-pct]', String(plan.pct));

      cards.forEach(function (card) {
        card.classList.toggle('is-on', card.getAttribute('data-po-card') === mode);
      });
      radios.forEach(function (r) {
        r.checked = r.value === mode;
      });

      if (mode === 'sub' && canSub) {
        hidden.value = plan.id;
        hidden.disabled = false;
      } else {
        hidden.value = '';
        hidden.disabled = true;
      }

      var btn = form.querySelector('[type="submit"]');
      var label = btn && (btn.querySelector('.button__text') || btn.querySelector('span'));
      if (btn && label && v.available && !btn.classList.contains('added') && !btn.classList.contains('loading')) {
        var price = mode === 'sub' && canSub ? subPrice : v.price;
        label.textContent = (root.dataset.atc || 'Add to cart') + ' · ' + money(price, data.money_format);
      }

      section.querySelectorAll('.shopify-payment-button').forEach(function (el) {
        el.style.display = mode === 'sub' ? 'none' : '';
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) {
          mode = r.value;
          render();
        }
      });
    });

    if (freq) {
      freq.addEventListener('change', function () {
        mode = 'sub';
        render();
      });
      freq.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    form.addEventListener('change', function () {
      setTimeout(render, 0);
    });
    section.addEventListener('change', function () {
      setTimeout(render, 0);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(render, 0);
      });
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-po]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();